import {
  connect,
  disConnect,
  selectCertificate,
  signMsgPKCS7,
  signHashMsgPKCS7Detached,
  getSignCertInfo,
  // CFCA_GetContainer,
  CFCA_PKCS10CertRequisition,
  CFCA_ImportSignCert,
  CFCA_SetKeyAlgorithm,
  CFCA_SetCSPInfo,
  getVersion
} from '../cryptokit/api'
import {
  cofco_connect,
  PKCS10Requisition_SingleCert,
  getContainer,
  InstallCert,
  CFCA_GetContainer
} from '../cofco/api'

import { tool } from 'rt-sd-common';

let http = (url,req) => {
  return new Promise((resolve, reject) => {
    commonClient.simplecall(url, req, (res) => {
      if (res && res.head && res.head.code === "0000") {
        let resObj = {
          errorcode:'0',
          result:res.head.msg
        }
        resolve(resObj)
      }else{
        let resObj = {
          errorcode:'-1',
          result:res.head.msg
        }
        reject(resObj)
      }
    })
  })
}
// 弹出 获取口令 获取key信息
export const verifyCertificate = ()=> {
  return connect().then(() => {
    return selectCertificate()
  }).then((result) => {
    return signMsgPKCS7()
  }).then((res) => {
    return getSignCertInfo("SubjectDN")
  })
  // 验证当前数据
  .then((d = "") => {
    console.log(d)
    let str = d.result
    let custCardNo = tool.getCookie('creditCode')
    console.log(custCardNo)
    return str.split("@").includes(`8${custCardNo}`)
  })
  .then((isPassed) => {
    let res = {
      errorcode:'1',
      result:'当前用户所属机构与所选证书不匹配'
    }

    return isPassed
      ? getSignCertInfo("SerialNumber")
      : Promise.reject(res);
  })
  // 请求后台
  .then((d) => {
    console.log(`当前证书序列号：${d.result}`);
    // let nikNam = tool.getCookie('nikNam');
    // console.log(`当前userName：${nikNam}`);
    let userId = tool.getCookie('userId');
    console.log(`当前userId：${userId}`);
    let serialNo = d.result;
    tool.setCookie("currentSerialNo", serialNo);

    let url = sgiConfig.service_file + '/cfca/checkCert';
    return http(url, { serialNo, userId });
  })
}


// 封装action
let actionList = [
  connect,
  cofco_connect,
  // InsertCcie,
  // verifyCertificate,
  PKCS10Requisition_SingleCert,
  CFCA_GetContainer,
  getContainer,
  // getCSPInfo,
  // applyCice
]
let cfcaActions = {}
actionList.map(el=>{
  cfcaActions[el.name] = (cb)=> {
    el().then((res) => {
      cb(res)
    }).catch((err) => {
      cb(err)
    })
  }
})

// key验证
cfcaActions.verifyCertificate = (cb) => {
  verifyCertificate().then((res) => {
    cb(res)
  }).catch((err) => {
    cb(err)
  });
}
// 带参方法
cfcaActions.InstallCert = (signCert, cb) => {
  InstallCert(1,signCert).then((res) => {
    cb(res)
  }).catch((err) => {
    cb(err)
  });
}

export default cfcaActions


// WEBPACK FOOTER //
// ./apps/cfca/action/index.js